import { Injectable } from '@angular/core';
import { ApiService } from './api.service';

@Injectable({
    providedIn: 'root',
})
export class LanguageService {

	constructor(
		public apiService: ApiService,
	) {
	}

/* 	getLanguageDictionary( language: string ): any {

        this.getLanguageDictionaryAPI(language).subscribe({
    
                next: (data: { translations: any; }) => {
                    console.log('POST request successful', data);
                    // Handle the successful response here
                    console.log("Utils: ", data);
                    if (data) {
                        //Store in memory
                        localStorage.setItem("translations", JSON.stringify(data.translations));
                    }
                },
                error: (error: { error: { message: any; }; }) => {
                    console.error('POST request failed', error);
                    // Handle the error here
                    //data=error.error.message;
                },
                complete: () => {
                    console.info('complete')
                }
        
        });

	}
 */
	getLanguageDictionary( language: string ): any {

		var body: any;

		body = {language: language};

		return this.apiService.post('/language/translations', body).pipe(response => response);

	}
	
}
